import { render, staticRenderFns } from "./BcbPartnerEdit.vue?vue&type=template&id=42ce9c92&scoped=true"
import script from "./BcbPartnerEdit.vue?vue&type=script&lang=js"
export * from "./BcbPartnerEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ce9c92",
  null
  
)

export default component.exports